import { useEffect, useState } from "react";
import { isDemoMode } from "../services/api";

/** Resolves to true when the app is serving client-side demo data. */
export function useDemoMode(): boolean {
  const [demo, setDemo] = useState(false);
  useEffect(() => {
    let active = true;
    isDemoMode().then((v) => {
      if (active) setDemo(v);
    });
    return () => {
      active = false;
    };
  }, []);
  return demo;
}
